module.exports = __webpack_public_path__ + "img/home_icon_jifenshangcheng.7b6c0c73.svg";